import React, { Suspense, lazy, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import { CartProvider } from "@/context/CartContext";

// Code-split route components so the initial bundle stays small (better
// Lighthouse Performance + faster TTI). Each page loads on demand.
const Home = lazy(() => import("@/pages/Home"));
const Shop = lazy(() => import("@/pages/Shop"));
const ProductDetail = lazy(() => import("@/pages/ProductDetail"));
const About = lazy(() => import("@/pages/About"));
const Contact = lazy(() => import("@/pages/Contact"));
const Policies = lazy(() => import("@/pages/Policies"));

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function RouteFallback() {
  return (
    <div
      className="flex min-h-[40vh] items-center justify-center"
      role="status"
      aria-live="polite"
    >
      <span className="font-script text-4xl text-hotpink animate-pulse">
        Pink things loading…
      </span>
    </div>
  );
}

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App flex min-h-screen flex-col">
          <div
            className="relative overflow-hidden bg-gradient-to-r from-magenta via-hotpink to-magenta py-2 text-white"
            data-testid="announcement-bar"
            aria-label="Announcement"
          >
            <div className="animate-marquee flex w-max items-center gap-12 whitespace-nowrap text-xs font-semibold uppercase tracking-[0.25em]">
              {Array.from({ length: 2 }).map((_, k) => (
                <React.Fragment key={k}>
                  <span>✦ Life is better in pink</span>
                  <span>✦ Curated with love in Andrews, Texas</span>
                  <span>✦ New pink arrivals every week</span>
                  <span>✦ Boutique girly gifts</span>
                  <span>✦ All things pink, one stop shop</span>
                  <span>✦ Free shipping over $75</span>
                </React.Fragment>
              ))}
            </div>
          </div>
          <Navbar />
          <div className="flex-1">
            <Suspense fallback={<RouteFallback />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/shop/:handle" element={<ProductDetail />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/policies" element={<Policies />} />
                <Route path="*" element={<Home />} />
              </Routes>
            </Suspense>
          </div>
          <Footer />
          <CartDrawer />
          <Toaster
            position="top-right"
            toastOptions={{
              style: {
                background: "#fff",
                border: "1px solid #ffc6dd",
                color: "#2d1b24",
                borderRadius: "9999px",
                padding: "10px 18px",
              },
            }}
          />
        </div>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
